module.exports = __webpack_public_path__ + "assets/icon-download.14bad7cc.svg";